package one.healthium.intercom

import co.touchlab.kermit.Logger
import one.healthium.domain.user.UserInteractor
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject

object Intercom : KoinComponent {
    suspend fun present() {
        try {
            val userInteractor = inject<UserInteractor>()
            val user = userInteractor.value.getUser()
            IntercomPlatform.present(user)
        } catch (e: Exception) {
            Logger.e("failed to present Intercom", e)
        }
    }
}